import pageNav from '../../../old-static/pageNav';
import rModal from '../../../old-static/rModal';

window.siteInfo = {};
window.siteInfo.isMobile = window.innerWidth < 1079;
window.siteInfo.deviceType = window.innerWidth > 1079
    ? 'desktop'
    : window.innerWidth < 767
        ? 'mobile'
        : 'tablet';

document.addEventListener('DOMContentLoaded', function () {
    initClipboard();
    newsShowPopup();
    initModals();

    // init photo gallery scripts
    const photoGalleryEl = document.getElementById('photo-gallery');
    if (photoGalleryEl) {
        pageNav({
            rootEl: photoGalleryEl,
            isModal: true,
            endpoint: '/ajax/photo_gallery.php',
            perPage: 9,
            mobilePerPage: 8
        });
    }

    // init video gallery scripts
    const videoGalleryEl = document.getElementById('r-video-gallery');
    if (videoGalleryEl) {
        pageNav({
            rootEl: videoGalleryEl,
            isModal: true,
            endpoint: '/ajax/video_gallery.php',
            perPage: 9,
            mobilePerPage: 8
        });
    }

    function newsShowPopup() {
        const popupObj = getPopupQueryString();

        if (popupObj) {
            rModal.showInPageStart(popupObj);
        }
    }

    function getPopupQueryString() {
        const qString = window.location.search;
        if (!qString) return;
        const qStringObj = new URLSearchParams(qString);
        let popupId = qStringObj.get('gallery-id');

        if(popupId) {
            return {
                type: 'gallery',
                id: popupId
            };
        }

        popupId = qStringObj.get('video-id');

        if (popupId) {
            return {
                type: 'video',
                id: popupId
            };
        }

        return false;
    }

    function initClipboard () {
        const parentEl = document.getElementById('common-socials');
        const el = parentEl.querySelector('._copy');
        const notifyEl = el.querySelector('.copy-notification');

        el.addEventListener('click', (e) => {
            e.preventDefault();

            navigator.clipboard.writeText(el.href);
            notifyEl.classList.add('_show');
            setTimeout(() => {
                notifyEl.classList.remove('_show');
            }, 1500);
        });
    }

    function initModals() {
        const modalTriggersEls = document.querySelectorAll('[data-modal]');

        if (modalTriggersEls.length) {
            modalTriggersEls.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();

                    const type = item.dataset.modal;
                    if (!type) return false;

                    rModal.show(item, type);
                });
            });
        }
    }
});